/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Banner_PlaceholderInputs */

const en_admin_email_settings_banner_placeholder = /** @type {(inputs: Admin_Email_Settings_Banner_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select file...`)
};

const de_admin_email_settings_banner_placeholder = /** @type {(inputs: Admin_Email_Settings_Banner_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen…`)
};

/**
* | output |
* | --- |
* | "Select file..." |
*
* @param {Admin_Email_Settings_Banner_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_banner_placeholder = /** @type {((inputs?: Admin_Email_Settings_Banner_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Banner_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_banner_placeholder(inputs)
	return en_admin_email_settings_banner_placeholder(inputs)
});